import Model from '@/models/Model.js';
import TermSchedule from '@/models/term-schedule/TermSchedule.js';
import TermSchedulePeriod from '@/models/term-schedule/TermSchedulePeriod.js';
import TermSchedulePeriodCourse from '@/models/term-schedule/TermSchedulePeriodCourse.js';
import TermTemplate from '@/models/term-template/TermTemplate.js';
import TermTemplatePeriod from '@/models/term-template/TermTemplatePeriod.js';
import TermTemplatePeriodCourseTemplate from '@/models/term-template/TermTemplatePeriodCourseTemplate.js';

export default class TermBuilder extends Model {
    static entity = 'terms_builder';

    static modelName = 'TermBuilder';

    constructor(record) {
        super(record);

        const isTemplate = record.term_type === 'template';

        this.isTemplate = isTemplate;
        this.termModel = isTemplate ? TermTemplate : TermSchedule;
        this.termPeriodModel = isTemplate ? TermTemplatePeriod : TermSchedulePeriod;
        this.termPeriodCourseTemplateModel = isTemplate ? TermTemplatePeriodCourseTemplate : TermSchedulePeriodCourse;
    }

    static fields() {
        return {
            id: this.number(null),
            term_type: this.string(null),
            // term_id: this.number(null),
        };
    }

    get model() {
        return this.term_type === 'template' ? TermTemplate : TermSchedule;
    }

    fetchTerm() {
        return this.termModel.fetch(this.id);
    }

    term() {
        const relations = this.isTemplate ? ['periods.courses'] : ['periods.courses', 'launched_groups'];
        return this.termModel.query().with(relations).find(this.id) ?? {};
    }

    periods() {
        const query = this.termPeriodModel.query().with('courses').orderBy('order');

        this.isTemplate ? query.where('term_schedule_template_id', this.id) : query.where('term_schedule_id', this.id);

        return query.get();
    }

    courses(periodId) {
        const query = this.termPeriodCourseTemplateModel.query().orderBy('order');

        this.isTemplate
            ? query.where('term_schedule_template_period_id', periodId)
            : query.where('term_schedule_period_id', periodId);

        return query.get();
    }
}
